<template>
	<div class="app-card-page">
		<slot />
	</div>
</template>

<style lang="scss">
.app-card-page {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	padding: 1.5rem;
	gap: 1rem;
	max-width: 1000px;
	width: 100%;
	margin: 0 auto;

	@media screen and (max-width: var(--mobile-size)) {
		padding: 0.75rem;
		gap: 0.75rem;
	}
}
</style>
